import {
  ID,
  rootId,
  SortingMode,
  Task,
  TaskListItemTypes,
  TaskListTreeItem,
  Timestamp,
  WeekDays,
} from '@griply/types';

import { getSortedTasks } from '../get-sorted-tasks';

export type BuildTasksTreeOptions = {
  tasks: Task[];
  customOrder?: Record<ID, ID[]>;
  sortingMode?: SortingMode | null;
  today: Timestamp;
  weekStartsOn: WeekDays;
  hideNewTaskRow?: boolean;
  rootLabel: string;
  newTaskLabel: string;
};

export const buildTasksTree = ({
  tasks,
  customOrder,
  sortingMode,
  today,
  weekStartsOn,
  hideNewTaskRow,
  rootLabel,
  newTaskLabel,
}: BuildTasksTreeOptions): Record<ID, TaskListTreeItem> => {
  const customTaskOrder = Object.values(customOrder ?? {}).flat();
  const taskTreeItems = getSortedTasks(tasks, {
    today,
    weekStartsOn,
    order: customTaskOrder,
    mode: sortingMode ? [SortingMode.DueDate, sortingMode] : undefined,
  }).reduce<Record<ID, TaskListTreeItem>>((acc, task) => {
    acc[task.id] = {
      id: task.id,
      name: task.name,
      type: TaskListItemTypes.Task,
    };
    return acc;
  }, {});

  const allTreeItems = { ...taskTreeItems };
  const children = Object.keys(taskTreeItems);

  if (!hideNewTaskRow) {
    const newTaskItemId = 'new-task';
    children.push(newTaskItemId);
    allTreeItems[newTaskItemId] = {
      id: newTaskItemId,
      name: newTaskLabel,
      type: TaskListItemTypes.NewTask,
    };
  }

  return {
    [rootId]: {
      id: rootId,
      name: rootLabel,
      type: TaskListItemTypes.Root,
      children,
    },
    ...allTreeItems,
  };
};
